export const DEFAULT_CDES_JSON = {
  "Demographic Information": [
    {
      "General Information Hierarchy": {
        display_name: "General Information Hierarchy",
        cde_values: [[]],
        visibility: true,
        sort_order: 1,
      },
    },
    {
      "Board Certification Hierarchy": {
        display_name: "Board Certification Hierarchy",
        cde_values: [[]],
        visibility: true,
        sort_order: 2,
      },
    },
    {
      "Medicaid Hierarchy": {
        display_name: "Medicaid Hierarchy",
        cde_values: [[]],
        visibility: true,
        sort_order: 3,
      },
    },
    {
      "DEA Hierarchy": {
        display_name: "DEA Hierarchy",
        cde_values: [[]],
        visibility: true,
        sort_order: 4,
      },
    },
    {
      "Medical Licensing Hierarchy": {
        display_name: "Medical Licensing Hierarchy",
        cde_values: [[]],
        visibility: true,
        sort_order: 5,
      },
    },
    {
      "Education Hierarchy": {
        display_name: "Education Hierarchy",
        cde_values: [
          [
            {
              "Individual Education Hierarchy": {
                display_name: "Individual Education Hierarchy",
                cde_values: [[]],
                visibility: true,
                sort_order: 6,
              },
            },
          ],
        ],
        visibility: true,
        sort_order: 6,
      },
    },
    {
      "Specialty Hierarchy": {
        display_name: "Specialty Hierarchy",
        cde_values: [[]],
        visibility: true,
        sort_order: 7,
      },
    },
  ],
  "Business Entity Information": [
    {
      "Associated Business Entity Hierarchy": {
        display_name: "Associated Business Entity Hierarchy",
        cde_values: [[]],
        visibility: true,
        sort_order: 38,
      },
    },
    {
      "Group/Facility Provider Hierarchy": {
        display_name: "Group/Facility Provider Hierarchy",
        cde_values: [[]],
        visibility: true,
        sort_order: 39,
      },
    },
  ],
  "General Information Hierarchy": [
    {
      "Practitioner First Name": {
        display_name: "Practitioner First Name",
        cde_values: [],
        visibility: true,
        sort_order: 1,
      },
    },
    {
      "Practitioner Middle Name": {
        display_name: "Practitioner Middle Name",
        cde_values: [],
        visibility: true,
        sort_order: 2,
      },
    },
    {
      "Practitioner Last Name": {
        display_name: "Practitioner Last Name",
        cde_values: [],
        visibility: true,
        sort_order: 3,
      },
    },
    {
      "Practitioner Date of Birth": {
        display_name: "Practitioner Date of Birth",
        cde_values: [],
        visibility: true,
        sort_order: 4,
      },
    },
    {
      "Practitioner Salutation": {
        display_name: "Practitioner Salutation",
        cde_values: [],
        visibility: true,
        sort_order: 5,
      },
    },
    {
      "Practitioner Suffix": {
        display_name: "Practitioner Suffix",
        cde_values: [],
        visibility: true,
        sort_order: 6,
      },
    },
    {
      "Practitioner Degree Suffix": {
        display_name: "Practitioner Degree Suffix",
        cde_values: [],
        visibility: true,
        sort_order: 7,
      },
    },
    {
      "Practitioner Sex": {
        display_name: "Practitioner Sex",
        cde_values: [],
        visibility: true,
        sort_order: 8,
      },
    },
    {
      "Practitioner Ethnicity": {
        display_name: "Practitioner Ethnicity",
        cde_values: [],
        visibility: true,
        sort_order: 9,
      },
    },
    {
      "Practitioner Primary Language": {
        display_name: "Practitioner Primary Language",
        cde_values: [],
        visibility: true,
        sort_order: 10,
      },
    },
    {
      "Practitioner Alternate Language": {
        display_name: "Practitioner Alternate Language",
        cde_values: [],
        visibility: true,
        sort_order: 11,
      },
    },
    {
      "Practitioner NPI": {
        display_name: "Practitioner NPI",
        cde_values: [],
        visibility: true,
        sort_order: 12,
      },
    },
    {
      "Medicare ID": {
        display_name: "Medicare ID",
        cde_values: [],
        visibility: true,
        sort_order: 13,
      },
    },
    {
      "Practitioner Email": {
        display_name: "Practitioner Email",
        cde_values: [[]],
        visibility: true,
        sort_order: 14,
      },
    },
  ],
  "Board Certification Hierarchy": [
    {
      "Board Certification Organization Name": {
        display_name: "Board Certification Organization Name",
        cde_values: [],
        visibility: true,
        sort_order: 1,
      },
    },
    {
      "Board Certification Number": {
        display_name: "Board Certification Number",
        cde_values: [],
        visibility: true,
        sort_order: 2,
      },
    },
    {
      "Board Certification Original Status": {
        display_name: "Board Certification Original Status",
        cde_values: [],
        visibility: true,
        sort_order: 3,
      },
    },
    {
      "Board Certification Original Issue Date": {
        display_name: "Board Certification Original Issue Date",
        cde_values: [],
        visibility: true,
        sort_order: 4,
      },
    },
    {
      "Board Certification Original Expiration Date": {
        display_name: "Board Certification Original Expiration Date",
        cde_values: [],
        visibility: true,
        sort_order: 5,
      },
    },
  ],
  "Medicaid Hierarchy": [
    {
      "Medicaid ID": {
        display_name: "Medicaid ID",
        cde_values: [],
        visibility: true,
        sort_order: 1,
      },
    },
    {
      "Medicaid State": {
        display_name: "Medicaid State",
        cde_values: [],
        visibility: true,
        sort_order: 2,
      },
    },
    {
      "Medicaid Start Date": {
        display_name: "Medicaid Start Date",
        cde_values: [],
        visibility: true,
        sort_order: 3,
      },
    },
    {
      "Medicaid End Date": {
        display_name: "Medicaid End Date",
        cde_values: [],
        visibility: true,
        sort_order: 4,
      },
    },
    {
      "Provider Type - Medicaid": {
        display_name: "Provider Type - Medicaid",
        cde_values: [],
        visibility: true,
        sort_order: 5,
      },
    },
  ],
  "DEA Hierarchy": [
    {
      "Drug Enforcement Agency ID": {
        display_name: "Drug Enforcement Agency ID",
        cde_values: [],
        visibility: true,
        sort_order: 1,
      },
    },
    {
      "Drug Enforcement Agency Licensing State": {
        display_name: "Drug Enforcement Agency Licensing State",
        cde_values: [],
        visibility: true,
        sort_order: 2,
      },
    },
    {
      "Drug Enforcement Agency Start Date": {
        display_name: "Drug Enforcement Agency Start Date",
        cde_values: [],
        visibility: true,
        sort_order: 3,
      },
    },
    {
      "Drug Enforcement Agency End Date": {
        display_name: "Drug Enforcement Agency End Date",
        cde_values: [],
        visibility: true,
        sort_order: 4,
      },
    },
  ],
  "Medical Licensing Hierarchy": [
    {
      "Medical Licensing Identifier": {
        display_name: "Medical Licensing Identifier",
        cde_values: [],
        visibility: true,
        sort_order: 1,
      },
    },
    {
      "Medical Licensing State": {
        display_name: "Medical Licensing State",
        cde_values: [],
        visibility: true,
        sort_order: 2,
      },
    },
    {
      "Medical Licensing Start Date": {
        display_name: "Medical Licensing Start Date",
        cde_values: [],
        visibility: true,
        sort_order: 3,
      },
    },
    {
      "Medical Licensing End Date": {
        display_name: "Medical Licensing End Date",
        cde_values: [],
        visibility: true,
        sort_order: 4,
      },
    },
    {
      "Medical Licensing Type": {
        display_name: "Medical Licensing Type",
        cde_values: [],
        visibility: true,
        sort_order: 5,
      },
    },
  ],
  "Individual Education Hierarchy": [
    {
      "Education Institution Name": {
        display_name: "Education Institution Name",
        cde_values: [],
        visibility: true,
        sort_order: 1,
      },
    },
    {
      "Education Start Date": {
        display_name: "Education Start Date",
        cde_values: [],
        visibility: true,
        sort_order: 2,
      },
    },
    {
      "Education End Date": {
        display_name: "Education End Date",
        cde_values: [],
        visibility: true,
        sort_order: 3,
      },
    },
    {
      "Education Degree": {
        display_name: "Education Degree",
        cde_values: [],
        visibility: true,
        sort_order: 4,
      },
    },
    {
      "Education Specialty": {
        display_name: "Education Specialty",
        cde_values: [],
        visibility: true,
        sort_order: 5,
      },
    },
    {
      "Education Type": {
        display_name: "Education Type",
        cde_values: [],
        visibility: true,
        sort_order: 6,
      },
    },
    {
      "Education Completion Flag": {
        display_name: "Education Completion Flag",
        cde_values: [],
        visibility: true,
        sort_order: 7,
      },
    },
  ],
  "Specialty Hierarchy": [
    {
      "Practitioner Specialty": {
        display_name: "Practitioner Specialty",
        cde_values: [],
        visibility: true,
        sort_order: 1,
      },
    },
    {
      "Practitioner Taxonomy Code": {
        display_name: "Practitioner Taxonomy Code",
        cde_values: [],
        visibility: true,
        sort_order: 2,
      },
    },
    {
      "Specialty Primary Flag": {
        display_name: "Specialty Primary Flag",
        cde_values: [],
        visibility: true,
        sort_order: 3,
      },
    },
  ],
  "Associated Business Entity Hierarchy": [
    {
      "Tax ID Number": {
        display_name: "Tax ID Number",
        cde_values: [],
        visibility: true,
        sort_order: 1,
      },
    },
    {
      "Business Entity Name": {
        display_name: "Business Entity Name",
        cde_values: [],
        visibility: true,
        sort_order: 2,
      },
    },
    {
      "Group Practice/Facility Website": {
        display_name: "Group Practice/Facility Website",
        cde_values: [],
        visibility: true,
        sort_order: 3,
      },
    },
  ],
  "Group/Facility Provider Hierarchy": [
    {
      "Group Practice/Facility NPI": {
        display_name: "Group Practice/Facility NPI",
        cde_values: [],
        visibility: true,
        sort_order: 1,
      },
    },
  ],
};
